var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loader',{attrs:{"message":"Loading..."},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),_vm._v(" "),(!_vm.loading)?_c('TrialPromoBox'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }